import { postFormEncoded } from '../utility/http';
import {
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_KEYCLOAK_CLIENT_SECRET,
  REACT_APP_KEYCLOAK_SCOPE
} from '../config';

export async function fetchLogin(
  username: string,
  password: string
): Promise<any> {
  try {
    const response : any = await postFormEncoded(
      `${REACT_APP_KEYCLOAK_URL}realms/${REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`,
      {
        username,
        password,
        client_id: REACT_APP_KEYCLOAK_CLIENT_ID,
        grant_type: 'password',
        client_secret: REACT_APP_KEYCLOAK_CLIENT_SECRET,
        scope: REACT_APP_KEYCLOAK_SCOPE
      }
    );
    /*
      +'RjJyRmhHbnYtTTJIbVB6RUlQbFBYMUJBc19SbXA4RHRVIn0.eyJleHAiOjE2OTg5MTQzNjUsImlhdC'
      +'I6MTY5ODkxNDA2NSwianRpIjoiZDlmYjVjNDUtNTI3Yy00MjA2LWE0YmMtYWY0YjgzNDQ0NWMzIiwi'
      +'aXNzIjoiaHR0cHM6Ly9rZXljbG9hay50ZWxlc3BhemlvLmNvbS9hdXRoL3JlYWxtcy90LWRyb21lcz'
      +'IiLCJhdWQiOlsiZG9ja2VyLW1hbmFnZXIiLCJhY2NvdW50Il0sInN1YiI6IjBiZGQ0ZTJkLTkxMmIt'
      +'NDA0NS1iOGI4LWFhZDk5ZTUyNGM0MyIsInR5cCI6IkJlYXJlciIsImF6cCI6ImZyb250LWVuZCIsIn'
      +'Nlc3Npb25fc3RhdGUiOiI3MmE4N2M1OS03MDBhLTQ1MDQtYWRhZi05N2ViZWQyYzc4MDciLCJhY3Ii'
      +'OiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbIioiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZm'
      +'xpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iLCJBRE1JTiIsImRlZmF1bHQtcm9sZXMtdC1kc'
      +'m9tZXMyIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb'
      +'3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVua'
      +'WQgZW1haWwgcHJvZmlsZSIsInNpZCI6IjcyYTg3YzU5LTcwMGEtNDUwNC1hZGFmLTk3ZWJlZDJjNzgwN'
      +'yIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiYWRtaW5zIHMiLCJncm91cHMiOlsiL2N0eF9nYW'
      +'xpYyJdLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhZG1pbl9zIiwiZ2l2ZW5fbmFtZSI6ImFkbWlucyIsIm'
      +'ZhbWlseV9uYW1lIjoicyIsImVtYWlsIjoidGVzdEB0ZWxlc3BhemlvLmNvbSJ9.dDAP2EeuxsB_qgqtRZ'
      +'SLXYeSoBoVXHNlRSkpYg6glRjNly-BO64N4oegE48LaDVZH5pkzV8vLszM-lxX3zq5T2u85GgJjXwI68'
      +'asZn_JCSmfoNQhlme7Ko-YxXuNSQxrnTF6v2Xx5tlDlUyaUu5ohlRmMEa6Uezuu5HXlw47HGIhgbM3PV'
      +'tqHEpIDERSmsL_CG9EC6n1VhaLXyKsySNVJZZiWfWm4nR7c6SlycGesNSV7YXgygDyg5adpclb9siIHR'
      +'yDl8DLBEqi4ag_o33l4BmLC3YdYLgmNulabQbYa6f1qPb5iUXjESPEEFhA9dHFacxR09jnbGaacdKEobyWig';

    const tokenRefresh = 'eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJmNjQ5YzIwMi1mN'
      +'GEyLTRjMzktYjA4Yi0yNDViNWVhY2RkMGUifQ.eyJleHAiOjE2OTg5MTU4NjUsImlhdCI6MTY5ODkxNDA2NSw'
      +'ianRpIjoiOGQ0YWQ5MTQtY2FlNC00Y2ZjLTllNGMtYjRhOGQ5N2Q3YjAwIiwiaXNzIjoiaHR0cHM6Ly9rZXlj'
      +'bG9hay50ZWxlc3BhemlvLmNvbS9hdXRoL3JlYWxtcy90LWRyb21lczIiLCJhdWQiOiJodHRwczovL2tleWNs'
      +'b2FrLnRlbGVzcGF6aW8uY29tL2F1dGgvcmVhbG1zL3QtZHJvbWVzMiIsInN1YiI6IjBiZGQ0ZTJkLTkx'
      +'MmItNDA0NS1iOGI4LWFhZDk5ZTUyNGM0MyIsInR5cCI6IlJlZnJlc2giLCJhenAiOiJmcm9udC1lbm'
      +'QiLCJzZXNzaW9uX3N0YXRlIjoiNzJhODdjNTktNzAwYS00NTA0LWFkYWYtOTdlYmVkMmM3ODA3Iiwic'
      +'2NvcGUiOiJvcGVuaWQgZW1haWwgcHJvZmlsZSIsInNpZCI6IjcyYTg3YzU5LTcwMGEtNDUwNC1hZGF'
      +'mLTk3ZWJlZDJjNzgwNyJ9._6sZPm7P_ZPiGVzHh0KPM9aVAnIx2NLeVmdf5YilzRc';
    const id_token = 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJNY'
      +'0VyS2JOSDBRRjJyRmhHbnYtTTJIbVB6RUlQbFBYMUJBc19SbXA4RHRVIn0.eyJleHAiOjE2OTg'
      +'5MTQzNjUsImlhdCI6MTY5ODkxNDA2NSwiYXV0aF90aW1lIjowLCJqdGkiOiJmNzA3ODgwNy0wZTk'
      +'3LTRhNTgtODM0Yy03MjRlM2Q3NzU4ZWQiLCJpc3MiOiJodHRwczovL2tleWNsb2FrLnRlbGVzcG'
      +'F6aW8uY29tL2F1dGgvcmVhbG1zL3QtZHJvbWVzMiIsImF1ZCI6WyJmcm9udC1lbmQiLCJkb2Nr'
      +'ZXItbWFuYWdlciJdLCJzdWIiOiIwYmRkNGUyZC05MTJiLTQwNDUtYjhiOC1hYWQ5OWU1MjRjND'
      +'MiLCJ0eXAiOiJJRCIsImF6cCI6ImZyb250LWVuZCIsInNlc3Npb25fc3RhdGUiOiI3MmE4N2M'
      +'1OS03MDBhLTQ1MDQtYWRhZi05N2ViZWQyYzc4MDciLCJhdF9oYXNoIjoiVVJ6ZmhySVRNc2hWO'
      +'FgwcXZNeGo2USIsImFjciI6IjEiLCJzaWQiOiI3MmE4N2M1OS03MDBhLTQ1MDQtYWRhZi05N2V'
      +'iZWQyYzc4MDciLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6ImFkbWlucyBzIiwiZ3Jvd'
      +'XBzIjpbIi9jdHhfZ2FsaWMiXSwicHJlZmVycmVkX3VzZXJuYW1lIjoiYWRtaW5fcyIsImdpdm'
      +'VuX25hbWUiOiJhZG1pbnMiLCJmYW1pbHlfbmFtZSI6InMiLCJlbWFpbCI6InRlc3RAdGVsZXNw'
      +'YXppby5jb20ifQ.lb1NdakrCGaNVJ8acVA1V0UNBzAaJ74h7_FvTh7m7FQ4d6IzrA04CjA5wxp'
      +'2eGw7KJyrV0yqFDsQ6T5QrdWi7d9Y-Zu5_jE3ydboayWh_7rvlMxJxjy1aHwFeg4JMJy8aRkzb'
      +'fbqA5pvVZxNzGOcpMKHpiwdpBL_W_YKMTh7RldDg_AmHgTu4RhuWZUOj2HRBW_hdNk0GT-'
      +'YF1nhko74uusMwyWyOL7SyzZg86qj9s11ZBmj1ld5tNnN6MsVrb7GUxbjgYqsFSCTO0jGdj'
      +'9aLF32vsOKh4lKt8B8MMdMwYv_6-R9K6lkaeYWlSytN9cYvCPJJdO0HbbfAltOwRBIaQ';
      

    const response = { 'data': {
      'access_token': token,
      'expires_in':300,
      'refresh_expires_in':1800,
      'refresh_token': tokenRefresh,
      'token_type':'Bearer',
      'id_token': id_token,
      'not-before-policy':0,
      'session_state':'72a87c59-700a-4504-adaf-97ebed2c7807',
      'scope':'openid email profile'}};*/
    /*const token = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJFM2JnVVE1Tkx6cm'
      +'dmSWtYZFYwM01xSzU0WFhEOElsSHVzTW40cEhTYVRNIn0.eyJleHAiOjE3MDA2NjA1ODEsImlhdCI6MTcwMDY'
      +'2MDI4MSwianRpIjoiMmYzOGY5OWEtZjM1NS00OTdhLTkzNGQtNjY0YjFhZjNkODE1IiwiaXNzIj'
      +'oiaHR0cHM6Ly9rZXljbG9hazI'
      +'udGVsZXNwYXppby5jb20vYXV0aC9yZWFsbXMvdC1kcm9tZXMzIiwiYXVkIjpbImRvY2tlci1tYW5hZ2VyIi'
      +'wiYWNjb3VudCJdLCJ'
      +'zdWIiOiJiZmU5Y2NlMi1mZGY1LTRkMjctYTg5YS03MGExY2I0MmRhYTQiLCJ0eXAiOiJCZWFyZXIiL'
      +'CJhenAiOiJmcm9udC1l'
      +'bmQiLCJzZXNzaW9uX3N0YXRlIjoiNzY1NmI1MzAtMGNmMS00NTQxLWExM…dGUiXSwicHJlZmVycmVkX3'
      +'VzZXJuYW1lIjoiY'
      +'WRtaW4iLCJnaXZlbl9uYW1lIjoiQWRtaW4iLCJmYW1pbHlfbmFtZSI6IklzdHJhdG9yIiwiZW1haWwiOiJ'
      +'tYXJjby5sdWNoZX'
      +'R0YUBncnVwcG9zaXN0ZW1hdGljYS5pdCJ9.DjeIn7XJfMkeRkxpGl3a5rWBSgSmsSDQMfoAGCzem4LWTtCY'
      +'rkeEkNrZyYObtNbB'
      +'IjKSYX0Dk2FbCaOfJRW5pacVm5F7y1k0AVbpGx0bC1QGOs0OHcEzPt88pplJlXWx3GRjRitrQm6xrTnEtM6FS'
      +'AhBu1oShvixL'
      +'ioSicmQT_jqsOb_CYaF0EAQ1GBXSWaeQaG6XgayvW710f3'
      +'-YolMDAY6HhU3jxFQqZF85_QNzLaHBRH4wWz3p4w0OaoY8WSmH9TQebfGT2iUqKC7LdGGMaI3JHYPyGDMb-'
      +'jxcHW9krbLtLe3OCIZ5yK1Ufj-eXW-VEet68M1cS4vwMPrZiBjg';
     
    response.data.token = token;*/
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
